import { KeyValueTableFilledTextTextValueCombinedProps } from './types';

const usePresenter = (props: KeyValueTableFilledTextTextValueCombinedProps): KeyValueTableFilledTextTextValueCombinedProps => {
  return props;
};

export default usePresenter;
